var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgSmile = function SvgSmile(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Smile' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,2 C11.869,2 2,11.869 2,24 C2,36.131 11.869,46 24,46 C36.131,46 46,36.131 46,24 C46,11.869 36.131,2 24,2 M24,48 C10.767,48 0,37.234 0,24 C0,10.766 10.767,0 24,0 C37.233,0 48,10.766 48,24 C48,37.234 37.233,48 24,48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,18 C19,19.657 17.657,21 16,21 C14.343,21 13,19.657 13,18 C13,16.343 14.343,15 16,15 C17.657,15 19,16.343 19,18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,18 C35,19.657 33.657,21 32,21 C30.343,21 29,19.657 29,18 C29,16.343 30.343,15 32,15 C33.657,15 35,16.343 35,18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,38 C18.801,38 14.08,34.729 12.255,29.86 L12.063,29.352 L13.937,28.648 L14.128,29.157 C15.662,33.25 19.63,36 24,36 C28.37,36 32.338,33.25 33.872,29.158 L34.063,28.648 L35.937,29.352 L35.745,29.861 C33.92,34.729 29.199,38 24,38"
  }));
};
SvgSmile = pure(SvgSmile);
SvgSmile.displayName = 'SvgSmile';
export default SvgSmile;